import { automaticProjectColor, isProjectColor, projectColorValue } from "../../projectAppearance"
import { personInitials } from "../../computers/people"

export function personColorValue(seed: string, color?: string): string {
    if (color && isProjectColor(color)) return projectColorValue(color)
    if (color?.startsWith("#")) return color
    return automaticProjectColor(seed)
}

/** The same flat tinted tile projects use, so a person reads as a peer of a project in every list. */
export function PersonGlyph({ name, glyph, color, size = "md" }: { name: string; glyph?: string; color?: string; size?: "sm" | "md" | "lg" | "xl" }) {
    const resolved = personColorValue(name, color)
    const dimension = size === "xl" ? "h-16 w-16 text-xl" : size === "lg" ? "h-9 w-9 text-xs" : size === "sm" ? "h-4 w-4 text-[8px]" : "h-5 w-5 text-[9px]"
    return (
        <span
            className={`inline-flex ${dimension} flex-none items-center justify-center rounded-full border font-semibold leading-none tracking-[-0.04em]`}
            style={{
                backgroundColor: `color-mix(in srgb, ${resolved} 12%, transparent)`,
                borderColor: `color-mix(in srgb, ${resolved} 40%, transparent)`,
                color: resolved,
            }}
            title={name}
            aria-label={name}
        >
            <span aria-hidden="true">{(glyph?.trim() || personInitials(name)).slice(0, 2)}</span>
        </span>
    )
}
